import React from "react";
import useLenis from "@/hooks/useLenis";
import { Hero } from "@/components/Hero";
import { Stats } from "@/components/Stats";
import { About } from "@/components/About";
import { DualPerspective } from "@/components/DualPerspective";
import { Manifesto } from "@/components/Manifesto";
import { Expertise } from "@/components/Expertise";
import { Experience } from "@/components/Experience";
import { Clients, Markets } from "@/components/Markets";
import { Testimonials } from "@/components/Testimonials";
import { LatestWriting } from "@/components/LatestWriting";
import { Credentials } from "@/components/Credentials";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Landing() {
  useLenis();
  return (
    <>
      <main>
        <Hero />
        <Stats />
        <About />
        <DualPerspective />
        <Manifesto />
        <Expertise />
        <Experience />
        <Clients />
        <Testimonials />
        <Markets />
        <Credentials />
        <LatestWriting />
        <Contact />
      </main>
      <Footer />
    </>
  );
}
